<template>
  <modal @ok="applyConfig" @cancel="$emit('cancel')">
    <h3 slot="header">Configuration</h3>

    <div slot="body" class="body-contents">
      <p>
        Select table columns:
      </p>

      <div class="columns">
        <div class="column">
          <div class="header">general</div>
          <label>
            <input type="checkbox" v-model="descriptions" />
            description
          </label>
        </div>

        <div v-for="column in allColumns" class="column">
          <div v-if="column.header" class="header">{{column.header}}</div>
          <label>
            <input type="checkbox" v-model="column.selected" @change="selectColumn(column)" />
            {{ shortLabel(column) }}
            <span v-if="column.definition.hasPeriod && !column.selected">
              day/month/year
            </span>
          </label>
          <drop-down v-if="column.definition.hasPeriod && column.selected"
                     :disabled="!column.selected"
                     :value="column.period"
                     :options="periodOptions"
                     :showFilter="false"
                     title="Click to select a period"
                      @change="(period) => column.period = period"></drop-down>
          <drop-down v-if="column.definition.hasTimezone && column.selected"
                     :disabled="!column.selected"
                     :value="column.timezone"
                     :options="timezoneOptions"
                     title="Click to select a timezone"
                      @change="(timezone) => column.timezone = timezone"></drop-down>

          <span v-if="column.definition.category === 'unix'">(s)</span>
          <span v-if="column.definition.category === 'timestamp'">(ms)</span>
        </div>
      </div>

      <p>
        <a href="#" v-on:click="resetConfig">reset to default</a>
      </p>
    </div>

  </modal>
</template>

<script>
import moment from 'moment-timezone'
import flatMap from 'lodash/flatMap'
import last from 'lodash/last'
import assign from 'lodash/assign'
import { DEFINITIONS, TIMEZONES, PERIODS } from '../tttime/tttime'
import Modal from './Modal'
import DropDown from './DropDown'
import { formatTimezone } from '../utils/formatTimezone'
import './Config.scss'

const DEFAULT_COLUMN_DEFINITIONS = [
  { type: 'unix' },
  { type: 'timestamp' },
  { type: 'isoString' },
  { type: 'dateTime', timezone: moment.tz.guess() }
]

const TIMEZONE_OPTIONS = TIMEZONES.map(period => {
  return {
    value: period,
    text: period.replace(/_/g, ' ')
  }
})

const PERIOD_OPTIONS = PERIODS.map(period => {
  return {
    value: period,
    text: period
  }
})

export default {
  name: 'config',

  components: {
    Modal,
    DropDown
  },

  props: ['config'],

  data: function () {
    return {
      allColumns: generateAllColumns(this.config.columns),
      descriptions: this.config.descriptions !== false, // true when absent
      timezones: TIMEZONES,
      timezoneOptions: TIMEZONE_OPTIONS,
      periods: PERIODS,
      periodOptions: PERIOD_OPTIONS
    }
  },

  methods: {
    resetConfig: function (event) {
      event.preventDefault()

      this.descriptions = true
      this.allColumns = generateAllColumns(DEFAULT_COLUMN_DEFINITIONS)
    },

    applyConfig: function () {
      const descriptions = this.descriptions
      const columns = this.allColumns
          .filter(column => column.selected)
          .map(column => {
            return {
              type: column.type,
              timezone: column.timezone,
              period: column.period
            }
          })

      const newConfig = {
        version: '3',
        descriptions,
        columns
      }

      this.$emit('ok', newConfig)
    },

    selectColumn: function (column) {
      const index = this.allColumns.indexOf(column)
      const entries = this.allColumns.filter(c => c.type === column.type)
      const isLast = column === last(entries)
      const definition = column.definition

      // insert a new entry if the last entry of this category is selected
      if (isLast && column.selected) {
        if (definition.hasTimezone || definition.hasPeriod) {
          this.allColumns.splice(index + 1, 0, createNewEntry(definition))
        }
      }

      // remove the last entrie(s) when there are multiple unselected at the end
      const len = entries.length
      if (!isLast && len >= 2 && !entries[len - 2].selected && !entries[len - 1].selected) {
        const lastIndex = this.allColumns.indexOf(entries[len - 1])
        this.allColumns.splice(lastIndex, 1)
      }
    },

    shortLabel: function (column) {
      // we don't pass the timezone and period, we display that in a dropdown
      return column.definition.label('', '').replace(' (s)', '').replace(' (ms)', '')
    },

    formatTimezone
  },

  DEFAULT_COLUMN_DEFINITIONS
}

function generateAllColumns (configuredColumns) {
  return flatMap(Object.keys(DEFINITIONS).map(type => {
    const definition = DEFINITIONS[type]

    const existingEntries = configuredColumns
      .filter(column => column.type === type)
      .map(column => assign({ selected: true }, column))

    const newEntry = (!definition.hasTimezone && !definition.hasPeriod && existingEntries.length > 0)
        ? []
        : [createNewEntry(definition)]

    return existingEntries.concat(newEntry)
      .map((column, index) => {
        const header = index === 0 ? definition.header : undefined
        return assign({ definition, header }, column)
      })
  }))
}

function createNewEntry (definition) {
  return {
    type: definition.type,
    timezone: definition.hasTimezone ? moment.tz.guess() : undefined,
    period: definition.hasPeriod ? 'day' : undefined,
    selected: false,
    definition
  }
}

</script>



// WEBPACK FOOTER //
// Config.vue?52d1234a